import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import CompletedProjectsPage from './pages/CompletedProjectsPage'
import ProjectDetailsPage from './pages/ProjectDetailsPage'
import ProductsPage from './pages/ProductsPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import BookingPage from './pages/BookingPage'
import ServicesPage from './pages/ServicesPage'
import TrainingAndConsultationPage from './pages/TrainingAndConsultationPage'
import GeneralContractorsLandingPage from './pages/GeneralContractorsLandingPage'
import FacilitiesManagersLandingPage from './pages/FacilitiesManagersLandingPage'
import CountertopsLandingPage from './pages/CountertopsLandingPage'
import FumeHoodsLandingPage from './pages/FumeHoodsLandingPage'
import CaseworkLandingPage from './pages/CaseworkLandingPage'
import SinksLandingPage from './pages/SinksLandingPage'
import SpecialtyCabinetsLandingPage from './pages/SpecialtyCabinetsLandingPage'
import CaseworkBlueprintsLandingPage from './pages/CaseworkBlueprintsLandingPage'
import EpoxyCountertopsLandingPage from './pages/EpoxyCountertopsLandingPage'
import SafetyAuditLandingPage from './pages/SafetyAuditLandingPage'
import TestimonialsPage from './pages/TestimonialsPage'
import PrivacyPage from './pages/PrivacyPage'

function ScrollToHash() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (!hash) return
    const el = document.getElementById(hash.slice(1))
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [pathname, hash])
  return null
}

function App() {
  return (
    <Router>
      <ScrollToHash />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<CompletedProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectDetailsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/training" element={<TrainingAndConsultationPage />} />
          <Route path="/general-contractors" element={<GeneralContractorsLandingPage />} />
          <Route path="/facilities-managers" element={<FacilitiesManagersLandingPage />} />
          <Route path="/countertops" element={<CountertopsLandingPage />} />
          <Route path="/fume-hoods" element={<FumeHoodsLandingPage />} />
          <Route path="/casework" element={<CaseworkLandingPage />} />
          <Route path="/sinks" element={<SinksLandingPage />} />
          <Route path="/specialty-cabinets" element={<SpecialtyCabinetsLandingPage />} />
          <Route path="/casework-blueprints" element={<CaseworkBlueprintsLandingPage />} />
          <Route path="/epoxy-countertops" element={<EpoxyCountertopsLandingPage />} />
          <Route path="/safety-audit" element={<SafetyAuditLandingPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App
